import styled from "styled-components";

const Card = styled.div<any>`
  border-radius: 5px;
  background: ${(props) => (props.color ? props.color : "#FFF")};
  box-shadow: 0px 10px 15px rgba(168, 168, 168, 0.2);
  border-radius: 5px;
`;

export default Card;
